import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TenantsService } from '../services/tenants.service';
import { Tenants } from '../enums/page-type.enum';
import { SelectionService } from '../services/selection.service';

@Injectable({ providedIn: 'root' })
export class TenantGuard {
  constructor(private tenantsService: TenantsService, private selectionService: SelectionService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let tenantUrlName = route.params.tenantUrlName as string;
    this.tenantsService.showWorkflows = tenantUrlName === Tenants.AllWorkflows;
    if (tenantUrlName === Tenants.AllTenants || tenantUrlName === Tenants.AllWorkflows) {
      tenantUrlName = null;
    }
    this.selectionService.clear();
    this.tenantsService.selectTenantByUrlName(tenantUrlName);
    return true;
  }
}
